import { useEffect } from "react";
import { handleDropFile } from "../helpers/multimedia";

const useFilePaste = ({ filesSelected, setFilesSelected, setOpenMessageFileSize, setFileType }) => {
    useEffect(() => {
        const handlePaste = (e) => {
            const items = e.clipboardData.items;
            let files = [];
            // Esto imprimirá cuántos items hay en el portapapeles.
            console.log("Estos son los archivos que vamos a mapear", items, items.length);
            for (const item of items) {
                if (item.kind === 'file' && (item.type.startsWith('image/') || item.type === 'application/pdf')) {
                    console.log("estos son los archivos que vamos a mapear", items);
                    files.push(item.getAsFile());
                }
            }

            if (files.length > 0) {
                let fileType = null;
                if (files[0].type.startsWith("image")) fileType = "image";
                if (files[0].type.startsWith("application")) fileType = "document";
                console.log("Archivos del tipo:", files[0].type);
                console.log("Archivos pegados", files);
                const fileType__toDrop = handleDropFile(files, filesSelected, setFilesSelected, fileType, setOpenMessageFileSize);
                setFileType(fileType__toDrop);
            }
        };

        document.addEventListener('paste', handlePaste);
        return () => {
            document.removeEventListener('paste', handlePaste);
        };
    }, [filesSelected, setFilesSelected, setOpenMessageFileSize, setFileType]);
};

export default useFilePaste;
